export const getChromeRuntime = () => chrome.runtime;
export const getChromeTabs = () => chrome.tabs;
export const getChromeWebRequest = () => chrome.webRequest;
export const getChromeWebNavigation = () => chrome.webNavigation;
export const getChromeDeclarativeNetRequest = () =>
  chrome.declarativeNetRequest;
export const getChromeIdentity = () => chrome.identity;
export const getChromeI18n = () => chrome.i18n;
export const getChromeStorage = () => chrome.storage;

// Older devices might return 'undefined': https://qustodio.atlassian.net/browse/CHR-172
export const getChromeSessionStorage = ():
  | chrome.storage.SessionStorageArea
  | undefined => chrome.storage.session;

export const getChromeLocalStorage = () => chrome.storage.local;
export const getChromeAlarms = () => chrome.alarms;
export const getChromeAction = () => chrome.action;
export const getChromeOmnibox = () => chrome.omnibox;
export const getChromeIdle = () => chrome.idle;
export const getChromeNotifications = () => chrome.notifications;
export const getChromeManagement = () => chrome.management;
export const getDocument = () => document;
export const getNavigatorConnection = () => navigator?.connection;
export const getNavigatorUserAgent = (): string | undefined =>
  navigator?.userAgent;
